var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerPurpose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 47,
    viewBox: "0 0 60 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_8513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 42.2422C28.6644 42.2422 28.3315 42.1118 28.0738 41.8538L16.9732 30.6218C10.3423 23.9125 10.3423 12.9929 16.9732 6.28366C20.1866 3.03224 24.4577 1.24219 29 1.24219C33.5423 1.24219 37.8134 3.03224 41.0268 6.28366C47.6577 12.9929 47.6577 23.9098 41.0268 30.6218L29.9262 41.8538C29.6711 42.1118 29.3356 42.2422 29 42.2422Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 42.2422C28.6644 42.2422 28.3315 42.1118 28.0738 41.8538L16.9732 30.6218C10.3423 23.9125 10.3423 12.9929 16.9732 6.28366C20.1866 3.03224 24.4577 1.24219 29 1.24219C33.5423 1.24219 37.8134 3.03224 41.0268 6.28366C47.6577 12.9929 47.6577 23.9098 41.0268 30.6218L29.9262 41.8538C29.6711 42.1118 29.3356 42.2422 29 42.2422Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6983 10.2422C25.2532 10.2422 24.8518 10.5011 24.6815 10.8981C24.5112 11.2951 24.6053 11.7521 24.9201 12.056L25.6983 12.8073V16.7995C25.6983 17.0813 25.5823 17.3515 25.3759 17.5508L20.9737 21.8008C18.8937 23.8088 20.3668 27.2422 23.3083 27.2422H34.6917C37.6332 27.2422 39.1063 23.8088 37.0263 21.8008L32.6241 17.5508C32.4177 17.3515 32.3017 17.0813 32.3017 16.7995V12.8073L33.0799 12.056C33.3947 11.7521 33.4888 11.2951 33.3185 10.8981C33.1482 10.5011 32.7468 10.2422 32.3017 10.2422H25.6983ZM27.8994 16.7995V12.3672H30.1006V16.7995C30.1006 17.6449 30.4484 18.4556 31.0676 19.0534L32.1985 20.1452C31.4096 19.968 30.5824 20.0038 29.809 20.2527L29.2915 20.4193C28.3879 20.7101 27.4109 20.7101 26.5073 20.4193L25.8882 20.2201C25.8463 20.2066 25.8042 20.1944 25.7619 20.1834L26.9324 19.0534C27.5516 18.4556 27.8994 17.6449 27.8994 16.7995Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_8513",
    x: 10.5,
    y: 0.742188,
    width: 39,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_8513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_8513",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPurpose);
export default __webpack_public_path__ + "static/media/marker_purpose.6ed72ad9c4bb93bedff22ad2bf503105.svg";
export { ForwardRef as ReactComponent };